import { render, staticRenderFns } from "./OrderView.vue?vue&type=template&id=003ce4c9&"
import script from "./OrderView.vue?vue&type=script&lang=js&"
export * from "./OrderView.vue?vue&type=script&lang=js&"
import style0 from "./OrderView.vue?vue&type=style&index=0&id=003ce4c9&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2489941515/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('003ce4c9')) {
      api.createRecord('003ce4c9', component.options)
    } else {
      api.reload('003ce4c9', component.options)
    }
    module.hot.accept("./OrderView.vue?vue&type=template&id=003ce4c9&", function () {
      api.rerender('003ce4c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrderView.vue"
export default component.exports